var exports = {
  "i": "xaee3c4fa--6d190e--wrapper",
};

module.exports = exports;
